/**
 * @module MobileMenu
 */

import Component from '../base/Component';
import Accordion from '../base/Accordion';

import './styles.css';

/**
 * Название компонента.
 */
export default class MobileMenu extends Component {
    static className = 'mobile-menu';
}

$(() => {
    initAccordion();
});

$(document).on('click', '.mobile-menu__list-btn', e => {
    const $currentItem = $(e.currentTarget);

    $currentItem.addClass('is-active');
    $currentItem.closest('.mobile-menu__list-item').addClass('is-active');
    $currentItem
        .closest('.mobile-menu')
        .find('.mobile-menu__login')
        .slideUp();
    $currentItem
        .closest('.mobile-menu')
        .find('.mobile-menu__back')
        .slideDown();
    $currentItem
        .closest('.mobile-menu__list-item')
        .find('.mobile-menu__hidden')
        .slideDown();

    $('.mobile-menu__list-item').each((i, item) => {
        const $item = $(item);

        if (!$item.hasClass('is-active')) {
            $item.slideUp();
        }
    });
});

$(document).on('click', '.mobile-menu__back', () => {
    $('.mobile-menu__login').slideDown();
    $('.mobile-menu__back').slideUp();
    $('.mobile-menu__list-btn').removeClass('is-active');
    $('.mobile-menu__hidden').hide();

    $('.mobile-menu__list-item').each((i, item) => {
        const $item = $(item);

        $item.slideDown();
        $item.removeClass('is-active');
    });
});

$(document).on('click', '.mobile-menu__login', () => {
    if ($(window).width() < 768 && document.location.pathname != '/auth-registration/') {
        document.location.href = '/auth-registration/#form-777-wrapper';
    } else {
        document.location.href = '/auth-registration/';
    }
});

/**
 * Инициализация аккордеонов
 */
function initAccordion() {
    const accordionAutoclose = new Accordion($('.accordion--autoclose'));
    accordionAutoclose.init({
        isMultiple: false,
    });
}
